<style scoped>
#botsgrid {
  display: grid;
  grid-template-areas:
    'tv'
    'list';
  grid-gap: 15px;
  grid-template-columns: 1fr;
}

@media all and (min-width: 800px) {
  #editbot {
    display: none;
  }
}

@media all and (max-width: 800px) {
  #botsgrid {
    grid-template-areas:
      'tv'
      'edit'
      'list';
    grid-template-columns: 1fr;
  }
  #edit {
    display: none;
  }
}

#botlist {
  grid-area: list;
  min-height: 480px;
}
#tv {
  grid-area: tv;
}
#editbot {
  grid-area: edit;
}
</style>

<template>
  <div id="botsgrid">
    <div
      id="tv"
      style="display: flex;"
    >
      <GridTV style="flex: 100%;" />
      <EditGrid
        v-show="$store.state.grids.editMode"
        id="edit"
        :bot="$store.state.grids.editBot"
        style="flex: 30%; min-width: 360px; margin-left: 10px;"
      />
    </div>
    <!-- <EditGrid
      v-show="$store.state.grids.editMode"
      id="editbot"
      :bot="$store.state.grids.editBot"
    /> -->
    <GridList id="botlist" />
  </div>
</template>

<script>
import Decimal from 'decimal.js'
import GridTV from './GridTV'
import GridList from './GridList'
import EditGrid from './EditGrid'

export default {
  name: 'Grids',
  components: {
    GridList,
    GridTV,
    EditGrid
  },
  watch: {
    '$store.state.sys.tradeExchange' (newExch) {
      // console.log('Bots tradeExchange changed')
      if (this.$store.state.grids.exchSymbol[newExch.Id]) {
        this.$store.state.grids.editGrid = { symbol: this.$store.state.grids.exchSymbol[newExch.Id] }
      }

      let newSymbol = 'BTC_USDT'
      if (
        this.$store.state.grids.exchSymbol &&
        this.$store.state.grids.exchSymbol[newExch.Id]
      ) {
        newSymbol = this.$store.state.grids.exchSymbol[newExch.Id]
      }
      const z = () => {
        if (this.$store.state.grids.symbol === newSymbol) {
          this.$store.state.grids.setSymbolNeeded = Date.now()
        }
        this.$store.state.grids.editGrid = { symbol: newSymbol }

        // console.log('bots.symbol changed')
      }
      this.$store.dispatch('updateSymbols', { z })
      // this.$store.dispatch('updateSymbols', { z }).then(() => {
      //   console.log('updateSymbols dispatch done222')
      // })

      // if (this.$store.state.trade.symbol === newSymbol) {
      //   this.$store.dispatch('updateAssetBalance')
      // } else {
      //   this.$store.state.trade.symbol = newSymbol
      // }

      // this.cleanTV()
      // this.tvWidget.chart().setSymbol(this.chartSymbol, () => {
      //   // console.log('symbol loaded')
      //   // this.saveNeeded()
      // })
    }
  },
  created () {
    Decimal.set({ toExpNeg: -10 })
  }
}
</script>
